import React, { FC } from 'react';
import { ReactComponent as Calendar } from '../../../assets/Common/Calendar.svg';

export const CalendarIcon: FC = () => <Calendar />;
